import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import React from 'react'
import { useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import CustomPagination from '../../shared/utils/CustomPagination';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import EditIcon from '@mui/icons-material/Edit';
import useClusterZoneStore from '../../store/useClusterZoneStore';
import { useApartmentByCluster } from '../../assets/api/useAdminApi';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';

const ClusterListTable = ({ clusterRow, isLoading, isEdit = true }) => {
    const { setClusterZone } = useClusterZoneStore();
    const [selectedRow, setSelectedRow] = useState({});
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [paginationModelApartment, setPaginationModelApartment] = useState({ page: 0, pageSize: 5 });
    const { data: ApartmentList, isLoading: isApartmentLoading } = useApartmentByCluster({ cluster_id: selectedRow?.id })
    const ApartmentRows = ApartmentList?.map((item, index) => ({
        sr_no: index + 1,
        ...item
    }))
    const { open, handleClickOpen, handleClose } = useDialog();

    const clusterColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "cluster_name",
            headerName: "Cluster Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "zone_name",
            headerName: "Zone Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "country_name",
            headerName: "Country Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "state_name",
            headerName: "State Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "city_name",
            headerName: "City Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        ...(isEdit
            ? [{
                field: "actions",
                type: "actions",
                headerName: "Actions",
                flex: 1,
                cellClassName: "actions",
                renderCell: (params) => (
                    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <Tooltip title="Edit">
                            <GridActionsCellItem
                                key={0}
                                icon={<EditIcon />}
                                label="Edit"
                                onClick={() => {
                                    const selectedCluster = clusterRow?.find(row => row?.id === params?.id);
                                    if (selectedCluster) {
                                        setClusterZone(selectedCluster);
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }
                                }}
                            />
                        </Tooltip>
                    </Box>
                ),
            }]
            : [])


    ];

    const apartementColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_status",
            headerName: "Apartment Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },



    ];

    const viewTrainerCourse = (row) => {
        setSelectedRow(row)
        handleClickOpen()
    };
    return (
        <>
            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={clusterRow}
                    columns={clusterColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    onRowClick={(params) => viewTrainerCourse(params.row)}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={clusterRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}


            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                {isApartmentLoading ? (
                    <DataGridSkeleton rowsNum={5} />
                ) : (
                    <DataGrid

                        rows={ApartmentRows}
                        columns={apartementColumns}
                        getRowId={(row) => row.id}
                        pagination
                        paginationModel={paginationModelApartment}
                        onPaginationModelChange={setPaginationModelApartment}
                        pageSizeOptions={[5]}
                        slots={{
                            pagination: () => (
                                <CustomPagination
                                    paginationModel={paginationModelApartment}
                                    setPaginationModel={setPaginationModelApartment}
                                    totalRows={ApartmentRows?.length || 0}
                                    pageSize={paginationModelApartment.pageSize}
                                />
                            ),
                        }}
                    />
                )}
            </MainDialogBox>
        </>
    )
}

export default ClusterListTable